import React from 'react';
import { IonIcon } from '@ionic/react';
import { caretUp, caretDown } from 'ionicons/icons';
import { formatPct, yoyTone } from '../utils/format';
import './su-components.css';

export interface YoYBadgeProps {
  value: number | null | undefined;
  /** pill (default) has a tinted background; inline is text only. */
  variant?: 'pill' | 'inline';
  /** Show "NEW" instead of a percentage (store has no LY base). */
  isNew?: boolean;
  showArrow?: boolean;
}

const YoYBadge: React.FC<YoYBadgeProps> = ({ value, variant = 'pill', isNew = false, showArrow = true }) => {
  const pill = variant === 'pill' ? ' pill' : '';
  if (isNew) return <span className={`su-yoy new${pill}`}>NEW</span>;
  const tone = yoyTone(value);
  return (
    <span className={`su-yoy ${tone}${pill} su-num`}>
      {showArrow && tone !== 'neutral' && <IonIcon icon={tone === 'pos' ? caretUp : caretDown} />}
      {formatPct(value)}
    </span>
  );
};

export default YoYBadge;
